import API_PATH from '../../../config/API_PATH'
import { BID, GET_BID_COUNT_SHWE_HOUR } from './contants'

export const postBidProduct = (data) => {
    return {
        type: BID,
        data,
        meta: {
            method: "POST",
            url: API_PATH.bid,
            query: data.query || {},
            callback: data?.callback || null,
        }
    }
}

export const getBidCountShweHour = () => {
  return {
    type: GET_BID_COUNT_SHWE_HOUR,
    meta: {
      method: "GET",
      url: API_PATH.shweHourBidCount,
      callback: null,
    }
  }
}